module.exports = __webpack_public_path__ + "static/teamplayer-37b44b59f06472492456b6d46fccf25b.png";